export const TabsItem : {
    name: string
}[] = [
    {
        name: 'HoróZcopo',
    },
    {
        name: 'Llamadas',
    },
]